import { FirebaseError } from '@firebase/util';

export const throwError = (error: unknown, errorMessage?: string): void => {
  if (error instanceof Error) {
    throw new Error(error.message);
  } else if (error instanceof FirebaseError) {
    throw new Error(error.code);
  } else if (typeof error === 'string') {
    throw new Error(error);
  } else if (errorMessage) {
    throw new Error(errorMessage || '');
  } else {
    throw new Error();
  }
};
